import React from "react";
const KnowledgeManagement = React.lazy(() => import('./KnowledgeManagement'));
const DetailKnowLedge = React.lazy(() => import('./DetailKnowledge'));
const CreateKnowledge = React.lazy(() => import('./CreateKnowledge'));
const UserPage = React.lazy(() => import('./UserPage'));
const AdminPenilaian = React.lazy(() => import('./AdminPenilaian'));
const AdminKategori = React.lazy(() => import('./AdminKategori'));
const AdminKompetensi = React.lazy(() => import('./AdminKompetensi'));
const AdminDashRangkuman = React.lazy(() => import('./AdminDashRangkuman'));

export const knowlegeManagementConfig = [
    {
        path: '/apps/KnowledgeManagement',
        element: <KnowledgeManagement />
    },
    {
        path: '/apps/KnowledgeManagement/detail/:id/:creator_id',
        element: <DetailKnowLedge />
    },
    {
        path: '/apps/KnowledgeManagement/create',
        element: <CreateKnowledge />
    },
    {
        path: '/apps/KnowledgeManagement/create/:id',
        element: <CreateKnowledge />
    },
    {
        path: '/apps/KnowledgeManagement/user/:id',
        element: <UserPage />
    },
    {
        path: '/apps/adminkm-penilaian/',
        element: <AdminPenilaian />,
        roleAccess: [
            'MP.PNL',
            'PNL.SES.BKIPMKHP',
            'PNL.SES.BRSDM',
            'PNL.SES.DJPB',
            'PNL.SES.DJPDSPKP',
            'PNL.SES.DJPRL',
            'PNL.SES.DJPSDKP',
            'PNL.SES.DJPT',
            'PNL.SES.IJ',
            'PNL.SES.PSD',
            'PNL.SES.SEKJEN',
        ],
    },
    {
        path: '/apps/adminkm-laporan',
        element: <AdminDashRangkuman />,
        roleAccess: [
            'MP.PNL',
            'PNL.SES.BKIPMKHP',
            'PNL.SES.BRSDM',
            'PNL.SES.DJPB',
            'PNL.SES.DJPDSPKP',
            'PNL.SES.DJPRL',
            'PNL.SES.DJPSDKP',
            'PNL.SES.DJPT',
            'PNL.SES.IJ',
            'PNL.SES.PSD',
            'PNL.SES.SEKJEN',
        ]
    },
    {
        path: '/apps/adminkm-kategori',
        element: <AdminKategori />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/adminkm-kategori/create',
        element: <AdminKategori />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/adminkm-kategori/edit',
        element: <AdminKategori />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/adminkm-kompetensi',
        element: <AdminKompetensi />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/adminkm-kompetensi/create',
        element: <AdminKompetensi />,
        roleAccess: ['ADMIN_TOOLS'],
    },
    {
        path: '/apps/adminkm-kompetensi/edit',
        element: <AdminKompetensi />,
        roleAccess: ['ADMIN_TOOLS'],
    },
];

